/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Api } from '../providers/api/api';

@Injectable()
export class ChatService extends Api {

    private base: string = this.getBaseUrl();

    /* get list of chats api*/
    public listChat(params: any): Observable<any> {
        return this.http.get(this.base + `chat/list`, { params });
    }

    /* get chat api*/
    public getChat(params: any): Observable<any> {
        return this.http.get(this.base + 'chat/get', { params });
    }

    /* get messages api*/
    public getMessages(params: any): Observable<any> {
        return this.http.get(this.base + 'chat/messages', { params });
    }
}


